// Layout.jsx
import React from "react";
import Navbar from "../components/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";

function Layout() {
  return (
    <div className="min-vh-100 d-flex flex-column">
      {/* <Navbar /> */}
      <main className="flex-grow-1">
        <Outlet />
      </main>
      {/* <Footer /> */}
    </div>
  );
}

export default Layout;
